var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ul',{staticClass:"menu bg-base-100 w-56 my-2 rounded-box h-screen-header shadow-xl"},[_c('SidebarNav')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }